import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, absUrl } from "@/lib/api";
import { UserCircle2 } from "lucide-react";

export default function TopBar() {
  const [active, setActive] = useState(null);

  useEffect(() => {
    let mounted = true;
    api.get("/characters/active")
      .then((r) => {
        if (mounted) setActive(r.data || null);
      })
      .catch(() => {
        if (mounted) setActive(null);
      });
    const id = setInterval(() => {
      api.get("/characters/active")
        .then((r) => mounted && setActive(r.data || null))
        .catch(() => {});
    }, 10000);
    return () => {
      mounted = false;
      clearInterval(id);
    };
  }, []);

  const portraitUrl = active?.id
    ? absUrl(`/api/characters/${active.id}/image/portrait.png`)
    : null;

  return (
    <header
      data-testid="topbar"
      className="sticky top-0 z-30 flex h-16 items-center justify-between border-b border-orange-100 bg-white/80 px-6 backdrop-blur"
    >
      <div className="flex items-center gap-2">
        <span className="text-lg font-semibold tracking-tight text-stone-800 md:hidden">
          Dom Studio
        </span>
      </div>
      <Link
        to="/characters"
        data-testid="active-character-avatar"
        className="flex items-center gap-3 rounded-full border border-orange-100 bg-white px-3 py-1.5 shadow-sm transition hover:border-orange-200 hover:shadow-md"
      >
        <div className="flex h-8 w-8 items-center justify-center overflow-hidden rounded-full bg-gradient-to-br from-orange-200 to-rose-200">
          {portraitUrl ? (
            <img
              src={portraitUrl}
              alt={active?.name || "Active character"}
              className="h-full w-full object-cover"
            />
          ) : (
            <UserCircle2 className="h-5 w-5 text-orange-600" />
          )}
        </div>
        <div className="leading-tight">
          <div className="text-xs font-semibold text-stone-800">
            {active?.name || "No character"}
          </div>
          <div className="text-[10px] uppercase tracking-wide text-orange-600">
            {active ? "active" : "tap to create"}
          </div>
        </div>
      </Link>
    </header>
  );
}
